// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1977":"1a4ea63b","1978":"1a4ea63b","9342":"89ad63a2"}[chunkId] + ".chunk.css";
};